// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "openotp_auth-" + chunkId + ".js?v=" + {"vendors-node_modules_rehype-highlight_index_js":"ab71fd2809a0ccd5b1f0","node_modules_nextcloud_dialogs_dist_chunks_index-Cp_Wd5Qd_mjs":"3e6d862059330e0300b0","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-Bp973DaS_mjs":"d3c1af848bbb8759fc2f"}[chunkId] + "";
};